import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import {OPERATING_SYSTEMS} from '../utils/operatingSystemUtils';
import { IconType } from '../components/atoms/icon/icon';
import viewRelatedSportsRooms from './viewRelatedSportsRooms';
import viewRelatedCountries from './viewRelatedCountries';
export default {
  title: 'General',
  attributeName: 'infoPages',
  helpText: '',
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the config',
      default: '',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: true,
    },
     {
      attributeName: 'available_in_countries',
      label: 'Available Countries',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedCountries,
      default: [],
      helpText: 'Select the countries where this configuration will be available.',
      exactWidth: '10rem',
    },
  ],
};
